import React, { useState } from 'react'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit, faSave, faCancel, faTrash } from '@fortawesome/free-solid-svg-icons'
import TickerSelect from '../TickerSelect/TickerSelect'
import './HoldingsEditor.css'

// Add icons to the library for later use
library.add(faEdit, faSave, faCancel, faTrash)

// Define the HoldingsEditor component
const HoldingsEditor = ({
  sleeveTickers,
  setSwappedTickers,
  swappedTickers,
}) => {
  // Define state variables
  const [bannedSearches, setbannedSearches] = useState({})
  const [showTypeHead, setShowTypeHead] = useState(null)

  // consolidate all the tickers into 1 list
  const originalEnteries = sleeveTickers?.flatMap(sleeve => sleeve.data.map(item => item.ticker));


  // Define event handlers
  const handleEditClick = (groupIndex, index, clear) => {
    if (clear) {
      setShowTypeHead(null)
    } else {
      setShowTypeHead(`${groupIndex}-${index}`)
    }
  }

  const handleEditSave = ({ oldTicker, newTicker, newName }) => {

    let tempDict = {}
    tempDict['originalTicker'] = oldTicker
    tempDict['newTicker'] = newTicker
    tempDict['newTickerName'] = newName

    // Check that newTicker does not already exists in swappedTickers
    if (!swappedTickers.some(ticker => ticker.originalTicker === oldTicker)) {
      setSwappedTickers(prevState => [...prevState, tempDict])
    }
    setShowTypeHead(null)
  }

  const handleEditUndo = ({ originalTicker }) => {
    const updatedSwappedTickers = swappedTickers.filter(
      ticker => ticker.originalTicker !== originalTicker
    )

    setSwappedTickers(updatedSwappedTickers)
  }

  // Define helper functions for rendering
  const renderTypeHead = ({ticker, index, wtCategory}) => {
    return (
      <TickerSelect
        placeholder={'Search A Ticker To Replace ' + ticker}
        updateSelection={selected =>
          handleEditSave({
            oldTicker: ticker,
            newTicker: selected.ticker,
            newName: selected.name
          })
        }
        tabIndex={index}
        bannedSearches={originalEnteries.concat(bannedSearches)}
        wtCategory={wtCategory}
      />
    )
  }

  const renderTableHeader = () => [
    <tr className='holdings-heading' key='heading1'>
      <th className='table-header-line1' colSpan='12'>
        {'HOLDINGS'}
      </th>
    </tr>,
    <tr className='holdings-heading' key='header'>
      <th className='table-header-line2' colSpan='2'>
        {'TICKER'}
      </th>
      <th className='table-header-line2' colSpan='4'>{'MORNING STAR CATEGORIES'}</th>
      <th className='table-header-line2' colSpan='6'>{'NAME'}</th>
    </tr>
  ]

  // This function is responsible for rendering the table body
  const renderTableBody = () => {
    // Check if sleeveTickers is defined and not empty
    if (!sleeveTickers || sleeveTickers.length === 0) {
      return null; // Return null if no data is available
    }

    // Map over each group in sleeveTickers
    return sleeveTickers.map((group, groupIndex) => {
      return (
        <React.Fragment key={group.assetClass}>
          {/* Render a row for the asset class */}
          < tr className='asset-class-row' key={groupIndex} >
            <td colSpan='14'>{group.assetClass}</td>
          </tr >
          {/* Map over the data array within each group */}
          {
            group.data.map((item, index) => {
              // Find the swapped ticker for the current item
              const swappedTicker = swappedTickers.filter(
                value => value.originalTicker === item.ticker
              )[0]
              // Get the new ticker name if a swapped ticker was found
              const swappedName = swappedTicker && swappedTicker.newTickerName;
              // Render a row for each item
              return (
                <tr className='holdings-tickers' key={index}>
                  <td colSpan='2' style={{ paddingLeft: '15px', padingRight: '15px' }}>
                    {/* Show the swapped ticker if available, otherwise show the original ticker */}
                    {swappedTicker ? (
                      <p style={{ margin: 0, padding: 0 }}>
                        <s style={{ margin: 0, padding: 0 }}>{swappedTicker.originalTicker}</s> {swappedTicker.newTicker}
                      </p>
                    ) : (
                      item.ticker
                    )}
                  </td>

                  <td colSpan='4' style={{ padding: '10px' }}>
                    {/* Show the category of the item */}
                    {' '}{item.wtCategory}
                  </td>

                  <td colSpan='8'>
                    <div style={{ display: 'flex', alignItems: 'center', paddingLeft: '20px' }}>
                      {!swappedTicker && (
                        <FontAwesomeIcon
                          icon={showTypeHead === `${groupIndex}-${index}` ? 'cancel' : 'edit'}
                          size='sm'
                          onClick={() => handleEditClick(groupIndex, index, showTypeHead === `${groupIndex}-${index}`)}
                          style={{ cursor: 'pointer', paddingRight: '20px' }}
                        />
                      )}
                      {swappedTicker ? (
                        <FontAwesomeIcon
                          icon={'trash'}
                          size='sm'
                          onClick={() => handleEditUndo({ originalTicker: item.ticker })}
                          style={{ cursor: 'pointer', paddingRight: '20px' }}
                        />
                      ) : null}
                      {showTypeHead === `${groupIndex}-${index}`
                        ? renderTypeHead({'ticker': item.ticker, 'index': index, 'wtCategory': item.wtCategory})
                        : swappedTicker
                          ? swappedName
                          : item.name}
                    </div>
                  </td>
                </tr>
              )
            })
          }
        </React.Fragment>
      );
    });
  }

  return (
    <div className='table-responsive'>
      <table className='holdings-editor-table'>
        <thead>{renderTableHeader()}</thead>
        <tbody>{renderTableBody()}</tbody>
      </table>
    </div>
  )
}

export default HoldingsEditor